import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { QuestionnairesService } from './questionnaires.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { QuestionariType } from '../model/questionnaire-response';
import { Errors, ErrorType } from 'src/app/shared/enums/error';

@Injectable({
  providedIn: 'root'
})
export class ConductService {

private patientSelectedId: string | null = null;
  private conductSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
  ) {
    this.conductSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getConduct() {
    return this.conductSubject.asObservable();
  }

  async loadConduct(patientId: string, user: IUser): Promise<void> {

    this.conductSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'conduct', patientId, user.practitionerId)
      .then(result => {
        if (result) {
          this.conductSubject.next({
            result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            today: { ...result?.today },
            lastQuestionnaire: { ...result?.lastQuestionnaire }
          });
        }
      });
  }

  async saveConduct({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadConduct(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de conduta.',
        error
      );
    }
  }

  async updateConduct({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadConduct(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de conduta.',
        error
      );
    }
  }
}
